import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import TestimonialTilesComponent from "./component";

const TestimonialTiles = () => {
  const data = useStaticQuery(testimonialsQuery);
  return <TestimonialTilesComponent {...data} />;
};

const testimonialsQuery = graphql`
  query TestimonialQuery {
    allStoryComposition(
      filter: { uri: { glob: "**/testimonials/**", ne: "testimonials" } }
    ) {
      edges {
        node {
          id
          shortDescription
          searchImage {
            extension
            publicURL
            childImageSharp {
              gatsbyImageData
            }
          }
          title
          uri
          devOnly
        }
      }
    }
    testimonialTiles {
      props {
        testimonialSubtitle
        testimonialTitle
      }
    }
  }
`;

export default TestimonialTiles;
